import EventBus from "../components/event-bus";
import {HTTP} from '../http-common';
import moment from 'moment';

export const commonMixins = {

    data: () => ({
            colors: ['#ffbb44', '#098de1', '#154174', '#c3202b', '#607d8b', '#444444', '#446626', '#cc9636', '#23727b'],
            menuData: [
                {

                }
            ],
            features: [
                {

                }
            ],
            menuslug: "",
            pageType: "",
            currentTab: "",
            menuParentSlug: "",
            systemYear: "2019",
            loginUserPermission: [],
        }),
    mounted: function () {

        var self = this;

        //check token if user came from rental
        var token = this.$route.query.token;
        if (token != undefined) {
            localStorage.setItem("tkn", token);
        }

        /* if Acces Token is not exits redirect to login page. */
        if (localStorage.getItem("tkn") == "" || localStorage.getItem("tkn") == null) {
            self.$router.push("/");
        }
        $("html, body").animate({scrollTop: 0}, 10);
    },
    created() {
        /*console.log("mixin created");*/
    },
    beforeMount() {

    },
    watch: {
        menuslug: function (menuslug) {
            var self = this;
            setTimeout(function () {
                self.menuActive(menuslug);
            }, 1000);
            //self.$store.dispatch('getRole');
        }
    },

    methods: {
        getMenuDetails: function (slug) {
            var self = this;
            var config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tkn")
                },
                params: {
                    'slug': slug,
                }
            };
            HTTP.get("get_menu_details", config)
                    .then(function (response) {

                        if (response.data.code == 200) {
                            self.currentTab = "";
                            self.menuData = response.data.content.menu_details;
                            self.menuslug = self.menuData.slug;
                            self.menuParentSlug = (self.menuData.parent_slug != null) ? self.menuData.parent_slug : self.menuData.slug;
                            self.pageType = self.menuData.page_type.split(',').sort();
                            if (self.menuData.features.length) {
                                $.each(self.menuData.features, function (i) {
                                    if(self.pastTab == self.removeSpacesString(self.menuData.features[i].name)){
                                        self.currentTab = self.pastTab; 
                                    }
                                    if (self.currentTab == "") {
                                        self.currentTab = self.removeSpacesString(self.menuData.features[i].name);
                                        /*if (response.data.content.features[i].id == 1) {
                                         self.currentTab = "discussion";
                                         } else if (response.data.content.features[i].id == 2) {
                                         self.currentTab = "attachment";
                                         } else if (response.data.content.features[i].id == 3) {
                                         self.currentTab = "attachment";
                                         }*/
                                    }
                                });
                            } else {
                                self.currentTab = self.removeSpacesString("Attachments");
                            }
                            self.changeTab(self.currentTab);
                            // Getting User Roles with Menu Details
                            self.$store.commit('changeUserRole', response.data.content.roles.id);
                            localStorage.setItem("user_role", response.data.content.roles.id);
                            localStorage.setItem("systemYear", response.data.content.system_year);
                            self.systemYear = response.data.content.system_year;
                            EventBus.$emit("systemYear", true, response.data.content.system_year);
                            if($(window).width() < 1100){
                                $(".app-sidebar-right").removeClass("toggled");
                                $(".app-sidebar-right").removeClass("toggled-2");
                            }
                        }

                    }).catch(function (err) {
                        self.catchHandler(err, function () {});
            });
            self.menuActive(slug);
        },
        getFeatures: function () {

            var self = this;
            var config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tkn")
                },
            };
            HTTP.get("get_features", config)
                    .then(function (response) {
                        if (response.data.code == 200) {
                            self.features = response.data.content;
                        }
                    }).catch(function (err) {
                        self.catchHandler(err, function () {});
            });
        },
        /* Get User Role Permission */
        getRole: function () {
            var self = this;
            var config = {
                headers: {Authorization: "Bearer " + localStorage.getItem("tkn")}
            };
            HTTP.get("user/role", config)
                .then(function (response) {
                    if (response.data.status == 'success') {
                        self.loginUserPermission = [];
                        /* localStorage.setItem("user_role", response.data.content.roles.id);
                        self.systemYear = response.data.content.system_year;
                        return response.data.content.roles.id; */
                        $.each(response.data.permissions, function (i) {
                            //console.log(response.data.permissions[i].id + " : " + response.data.permissions[i].name);
                            self.loginUserPermission.push(response.data.permissions[i].name);
                        });
                        EventBus.$emit('roleAndPermissions', false, response.data.roles.id, response.data.roles.name, response.data.system_year, self.loginUserPermission);
                    }
                })
                .catch(function (err) {                    
                    if (err.response.status == 0) {
                        self.error = "Remote server can not be reachable";
                    } else {
                    //redirect to login page if user not authenticated
                    if (err.response.status == 401) {
                        let current_build = window.localStorage.getItem("build_version");
                        localStorage.clear();
                        localStorage.setItem("build_version", current_build);
                        window.location.href = process.env.SSO_ROOT_URL + "/logout?redirect=" + process.env.FRONT_ROOT_URL + '&slug=' + process.env.PROJECT_SLUG;
                    }
                }
            });
        },
        
        //make sentence first letter capital
        ucString: function (data) {
            var self = this;
            var value = data.replace(/_/g, " ");
            var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                return letter.toUpperCase();
            });
            return upp;
        },
        menuActive: function (slug) {
            /* console.log(slug); */
        //setTimeout(function () {
            $(".menuCommon").removeClass("active");
            $("." + slug).addClass("active");
            $("." + slug).parent().show();
            $('#menu ul').children('.current').parent().show();
            $('#menu li a').click(
                function() {
                    var checkElement = $(this).next();
                    if ((checkElement.is('ul')) && (checkElement.is(':visible'))) {
                        return false;
                    }
                    if ((checkElement.is('ul')) && (!checkElement.is(':visible'))) {
                        $('#menu ul:visible').slideUp('normal');
                        checkElement.slideDown('normal');
                        return false;
                    }
                }
            );

        //}, 1000);
        },
        changeTab: function (tab) {
            var self = this;
            self.currentTab = tab;
            if (tab == "discussion") {
                $(".btnDiscussion").removeClass("btn-outline-primary");
                $(".btnDiscussion").addClass("btn-primary");
                $(".btnAttachment").removeClass("btn-primary");
                $(".btnAttachment").addClass("btn-outline-primary");
            } else {
                $(".btnAttachment").removeClass("btn-outline-primary");
                $(".btnAttachment").addClass("btn-primary");
                $(".btnDiscussion").removeClass("btn-primary");
                $(".btnDiscussion").addClass("btn-outline-primary");
            }
        },
        utcToLocal: function (dateTime, format) {
            var self = this;
            var local = moment.utc(dateTime).local().format(format);
            return local;
        },
        formatDateTime: function (dateTime, format) {
            var self = this;
            var dateTime = new Date(dateTime);
            var dateTime = moment(dateTime).format(format);
            return dateTime;
        },
        gerRandomColor: function () {
            var self = this;
            var item = self.colors[Math.floor(Math.random() * self.colors.length)];
            return item;
        },
        showSAlert: function (message, type, callback) {
            this.$swal.fire(
                    message,
                    '',
                    type
                    );
            //callback("message");
        },
        catchHandler: function (err, callback) {
            var self = this;
            switch (err.response.status) {
                case 0:
                    this.showSAlert('Remote server can not be reachable', 'error', callback);
                case 400:
                    this.showSAlert(err.response.data.message, 'error', callback);
                    break;
                case 401:
                    let current_build = window.localStorage.getItem("build_version");
                    localStorage.clear();
                    localStorage.setItem("build_version", current_build);
                    window.location.href = process.env.SSO_ROOT_URL + "/login?redirect=" + process.env.FRONT_ROOT_URL + '&slug=' + process.env.PROJECT_SLUG;
                    break;
                case 404:
                    this.showSAlert(err.response.data.message, 'error', callback);
                    break;
                case 409:
                    this.showSAlert(err.response.data.message, 'error', callback);
                    break;
            }
        },
        removeSpacesString: function (srting) {
            return srting.replace(/\s/g, '').toLowerCase();
        },
        stringTrim: function (string, length) {
            length = (typeof length !== 'undefined') ? length : 20;
            var string1 = (string.length > length) ? string.substring(0, length) + '...' : string;
            return string1;
        },
        showLoader: function () {
            $(".loading-container").show();
        },
        hideLoader: function () {
            //setTimeout(function () {
                $(".loading-container").hide();
            //}, 1700);
        },
        firstLoadMenu: function () {
            var self = this;
            $('#menu ul').hide();
        },
        enableDisableButton: function (identifire,is_disable,is_id) {
            if(is_id == true){
                $('#'+identifire).attr("disable", is_disable);
            } else {
                $('.'+identifire).attr("disable", is_disable);
            }
        },
        arrayContainsArray: function (superset, subset) {
            var resp = false;
            $.each(superset, function (i) {
                $.each(subset, function (j) {
                    if(superset[i] == subset[j]){
                        resp = true;
                    }
                });
            });
            /*return subset.every(function (value) {
             return (superset.indexOf(value) >= 0);
             });*/
            return resp;
        },
    },
    computed: {
        user_role: {
            get: function () {
                return this.$store.getters.roles;
            },
            set: function (value) {
                this.$store.commit('changeUserRole', value);
            }
        },
        pastTab: {
            get: function () {
                return this.$store.getters.past_tab;
            },
            set: function (value) {
                this.$store.commit('changePastTab', value);
            }
        },
    }
};


// WEBPACK FOOTER //
// ./src/mixins/commonMixins.js